<div class="myc-controls-bar">
    <year-pills
        class="myc-controls-bar__years"
        [yearLabels]="yearLabels"
        [selectedYears]="selectedYears"
        (toggle)="yearToggled.emit($event)">
    </year-pills>

    <div class="myc-controls-bar__second-row">
        <report-scope-toggle
            class="myc-controls-bar__scope"
            [scope]="reportScope"
            (scopeChange)="reportScopeChanged.emit($event)">
        </report-scope-toggle>

        <div class="myc-controls-bar__group">
            <delta-mode-toggle
                [mode]="deltaMode"
                (modeChange)="deltaModeChanged.emit($event)">
            </delta-mode-toggle>

            <ratio-toggle
                [active]="structMode"
                [available]="hasReferenceValue"
                (toggle)="structModeToggled.emit()">
            </ratio-toggle>

            <!--
                Language switch — only renders when the company has reports
                in 2+ locales. Hidden in the common single-locale case so it
                doesn't clutter the controls bar.
            -->
            <myc-language-switch
                *ngIf="hasMultipleLanguages"
                [availableLanguages]="availableLanguages"
                [activeLanguage]="activeLanguage"
                (languageChanged)="languageChanged.emit($event)">
            </myc-language-switch>

            <ham-button
                *ngIf="!isAllExpanded"
                variant="white"
                outline="true"
                (click)="showAllDetails.emit()">
                {{ 'aumico_reports_equality_check_print_preview_show_details' | i18next }}
            </ham-button>
            <ham-button
                *ngIf="isAllExpanded"
                variant="white"
                outline="true"
                (click)="hideAllDetails.emit()">
                {{ 'aumico_reports_equality_check_print_preview_hide_details' | i18next }}
            </ham-button>

            <!--
                Export PDF — async via Pub/Sub. Disabled while a job is in flight to
                avoid duplicate publishes; the spinner UX is up to the caller.
            -->
            <ham-button
                variant="primary"
                [disabled]="exportInFlight"
                (click)="exportPdf.emit()">
                {{ (exportInFlight ? 'aumico_pdf_my_export_button_pending' : 'aumico_pdf_my_export_button') | i18next }}
            </ham-button>
        </div>
    </div>
</div>
